export default "__VITE_ASSET__9JR64bAX__"